import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';
import { API_URL } from '../config/api';
import LoadingIndicator from '../Components/LoadingIndicator';

const Forget = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setEmail(e.target.value);
    if (error) {
      setError('');
    }
  };

  const validateEmail = () => {
    if (!email.trim()) {
      setError('Email is required');
      return false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email.trim())) {
      setError('Please enter a valid email address');
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateEmail()) {
      return;
    }

    setIsLoading(true);

    try {
      if (!API_URL) {
        throw new Error('Service is not configured. Please try again later.');
      }

      const payload = {
        action: 'passwordResetEmail',
        email: email.trim(),
        platform: 'web',
      };

      const response = await axios.post(API_URL, payload, {
        headers: {
          'Content-Type': 'application/json'
        }
      });

      const result = response.data;
      toast.success(result?.message || 'Password reset link sent to your email');
      setEmail('');
      setTimeout(() => {
        navigate('/');
      }, 2000);
    } catch (error) {
      console.error('Forgot password error:', error);
      const errorMessage = error.response?.data?.message || error.message || 'Failed to send reset link. Please try again.';
      toast.error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-left-panel">
        <div className="login-left-brand">
          <span className="login-brand-dot"></span>
          <div>
            <img
              src="/assets/img/Website_logo_color logo-black text-1.png"
              alt="Office logo"
              className="login-brand-logo"
            />
          </div>
        </div>
        <div className="login-left-illustration">
          <img
            src="/assets/img/forgot.png"
            alt="Forgot password illustration"
            className="login-left-image"
          />
        </div>
      </div>

      <div className="login-right-panel">
        <div className="login-right-inner">
          <h5 className="login-heading">Forgot Password</h5>
          <p style={{ 
            color: '#6b7280', 
            fontSize: '14px', 
            marginBottom: '24px',
            lineHeight: '1.5'
          }}>
            Enter your email address and we'll send you a link to reset your password.
          </p>
          <form onSubmit={handleSubmit} noValidate>
            <div className="login-field">
              <label htmlFor="email" className="login-label">Email Address</label>
              <div className="login-input-row">
                <input
                  type="email"
                  id="email"
                  name="email"
                  className={`login-input-line ${error ? 'error' : ''}`}
                  placeholder="Enter your email"
                  value={email}
                  onChange={handleChange}
                  autoComplete="email"
                  aria-invalid={error ? 'true' : 'false'}
                  aria-describedby={error ? 'email-error' : undefined}
                />
              </div>
              {error && (
                <span className="error-message" id="email-error" role="alert">
                  <i className="fas fa-exclamation-circle"></i> {error}
                </span>
              )}
            </div>

            <button
              type="submit"
              className={`login-primary-btn ${isLoading ? 'loading' : ''}`}
              disabled={isLoading}
              style={{ marginBottom: '16px' }}
            >
              {isLoading ? (
                <>
                  <LoadingIndicator size={22} className="login-button-loader" />
                  <span style={{ marginLeft: '8px' }}>Sending...</span>
                </>
              ) : (
                'Send Reset Link'
              )}
            </button>

            <div className="login-forgot" style={{ textAlign: 'center' }}>
              <Link to="/">
                <i className="fas fa-arrow-left" style={{ marginRight: '6px' }}></i>
                Back to Login
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Forget;
